module.exports = __webpack_public_path__ + "img/final_4.45917602.png";